<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="showProjectDia"
    title="错误列表展示"
    :before-close="dialogCancel"
    append-to-body
    width="60%"
  >
    <el-container style="overflow: auto">
      <el-container>
        <el-main style="padding: 0">
          <el-table
            :data="listData"
            ref="orgTable"
            stripe
            border
            height="485"
            class="org-table"
            size="medium"
            style="width: 100%"
          >
            <el-table-column
              prop="no"
              label="编号"
              :show-overflow-tooltip="true"
              width="120"
              fixed
            ></el-table-column>
            <el-table-column
              prop="error"
              label="错误信息"
              :show-overflow-tooltip="true"
              min-width="120"
            >
              <template slot-scope="scope">
                <el-row v-for="(item, index) in scope.row.error" :key="index">
                  {{ translateErrMsgFuns(item.numericErrorCode) }}
                </el-row>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
      </el-container>
    </el-container>
    <span slot="footer" class="dialog-footer" style="text-align: center">
      <el-button size="small" type="primary" @click="dialogCancel"
        >确认</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import utils from "@/utils";
export default {
  name: "mesErrorTable",
  data() {
    return {
      showProjectDia: false
    };
  },
  props: {
    listData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    translateErrMsgFuns(key) {
      return utils.translateErrMsg(key);
    },
    // 选择项目弹框取消
    dialogCancel() {
      this.showProjectDia = false;
    },
    dialogOpen() {
      this.showProjectDia = true;
    }
  }
};
</script>
